export default {
    url: /(?:www\.)?([a-zA-Z0-9_-]+)(?:\.[a-zA-Z]+)+/,
    youTubeUrl: /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/,
    passwordComplexity: /(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})/,
}